/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Button, Row } from "reactstrap";

// core components

// Runtime-assembled contact address, kept out of the JS bundle so email-harvesting
// bots that regex the source/bundle can't scrape it. Real users still get a normal
// clickable mailto link. Assembled via .map().join() so the minifier can't fold it
// back into a literal string.
const CONTACT_EMAIL = [
  105, 110, 102, 111, 64, 114, 101, 100, 115, 99, 101, 112, 116, 114, 101, 46, 99, 111, 109,
]
  .map((c) => String.fromCharCode(c))
  .join("");

function Footer() {
  return (
    <>
      <footer className="footer footer-white">
        <Container style={{ paddingBottom: "2em", paddingTop: "2em" }}>
          <img src={require("assets/img/redsceptre-icon.png").default} width={80} height={80} />
        </Container>
        <Container style={{ marginBottom: "1em" }}>
          <ul className="social-buttons pull-center">
            <li>
              <Button
                className="btn-icon btn-neutral"
                color="linkedin"
                href="https://www.linkedin.com/company/redsceptre/"
                target="_blank"
              >
                <i className="fab fa-linkedin"></i>
              </Button>
            </li>
            <li>
              <Button
                className="btn-icon btn-neutral"
                color="github"
                href="https://github.com/redsceptre"
                target="_blank"
              >
                <i className="fab fa-github"></i>
              </Button>
            </li>
          </ul>
        </Container>
        <Container style={{ fontFamily: "AvantGardeGothicRegular", paddingBottom: "6em" }}>
          <Row className="pull-center" style={{ paddingBottom: 2 }}>
            <a href={`mailto:${CONTACT_EMAIL}`} target="_blank" rel="noreferrer">
              {CONTACT_EMAIL}
            </a>
          </Row>
          <br />
          <Row className="pull-center" style={{ paddingBottom: 2 }}>
            124 City Road, London, EC1V 2NX
          </Row>
          <br />
          <Row className="pull-center" style={{ paddingBottom: 2 }}>
            © {new Date().getFullYear()}.
            Redsceptre IT Solutions LTD is a registered company in England and Wales &nbsp;
            <a href="https://find-and-update.company-information.service.gov.uk/company/12422542" target="_blank">№ 12422542</a>
          </Row>

        </Container>
      </footer>
    </>
  );
}

export default Footer;
